import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteCloneAtom = createMutationAtomFactory(
  'brokerage.quoteClone',
  (params: { id: string; accountIds: string[] }) => ({
    tradeQuoteClone: {
      __args: {
        id: params.id,
        accountIds: params.accountIds,
      },
      id: true,
      documentNumber: true,
      status: true,
      accountId: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
);
